import Button from '@mui/material/Button'
import { CircularProgress } from '@mui/material'
import { useCreate } from '@refinedev/core'
import { UUID } from 'crypto'

interface GenerateProfileProps {
  opportunityUuid: UUID
  onSuccess?: (profile: string) => void
  hasExistingProfile?: boolean
  description?: string
  criteria?: string
  exclusions?: string
  fund_name?: string
}

export default function GenerateProfileButton({
  opportunityUuid,
  onSuccess,
  description,
  criteria,
  exclusions,
  fund_name,
  hasExistingProfile = false,
}: GenerateProfileProps) {
  const { mutate, isLoading } = useCreate()

  async function handleGenerateProfile() {
    mutate(
      {
        resource: 'opportunities',
        values: {
          description: description,
          criteria: criteria,
          exclusions: exclusions,
          fund_name: fund_name,
        },
        meta: { generateProfileUrl: `/generate-profile/${opportunityUuid}` },
        errorNotification: (error) => {
          return {
            message: 'Error generating profile',
            description:
              error?.message || 'An error occurred while generating profile',
            type: 'error',
          }
        },
      },
      {
        onSuccess: (response) => {
          if (onSuccess && response.data.profile) {
            onSuccess(response.data.profile)
          }
        },
      }
    )
  }

  return (
    <Button
      onClick={handleGenerateProfile}
      disabled={isLoading}
      startIcon={isLoading ? <CircularProgress size={20} /> : null}
    >
      {isLoading
        ? 'Generating Profile...'
        : hasExistingProfile
        ? 'Regenerate Profile'
        : 'Generate Profile'}
    </Button>
  )
}
